import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

// Só para a API da Fila: cabeçalho próprio em host de terceiro pode cair no preflight do CORS.
@Injectable()
export class VersaoAppInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const versao = (environment as { version?: string }).version;
    if (!versao || !req.url.startsWith(environment.apiUrl)) return next.handle(req);
    return next.handle(req.clone({ setHeaders: { 'X-Versao-App': versao } }));
  }
}
